import React, { useRef } from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import NSText from "./NSText";
import { AntDesign } from "@expo/vector-icons";
import ClearFilter from "./ClearFilter";
import GlobalMultiSelectNestedPicker from "./GlobalMultiSelectNestedPicker";

interface NestedDataType {
  id: string;
  name: string;
  children:
    | {
        id: string;
        name: string;
        children: { id: string; name: string }[] | null;
      }[]
    | null;
}

interface PropTypes {
  dropDownWidth?: number;
  defaultTitle?: string;
  setMiscModal: any;
  data: NestedDataType[];
  selectedIds: string[];
  selectedItem: string;
  canClearFilter: boolean;
  onItemPress: (value: any, index: number) => void;
  onClearFilter: () => void;
  hasSearch?: boolean;
}

const MultiSelectNestedDropDown = ({
  dropDownWidth,
  defaultTitle,
  setMiscModal,
  data,
  selectedIds,
  selectedItem,
  canClearFilter,
  onItemPress,
  onClearFilter,
}: PropTypes) => {
  const ref = useRef<TouchableOpacity>();

  const dropDownOnPress = () => {
    ref.current.measure((_, _1, width, height, pageX, pageY) => {
      setMiscModal(true, { x: pageX, y: pageY + height }, () => (
        <GlobalMultiSelectNestedPicker
          width={dropDownWidth ?? width}
          coords={{ x: pageX, y: pageY + height }}
          data={data}
          selectedIds={selectedIds}
          onItemPress={onItemPress}
        />
      ));
    });
  };

  return (
    <TouchableOpacity
      ref={ref}
      style={[
        styles?.container,
        {
          maxWidth: dropDownWidth || 200,
          borderColor: canClearFilter ? "#6300A31A" : "#6300A333",
          backgroundColor: canClearFilter ? "#6300A31A" : "",
        },
      ]}
      onPress={dropDownOnPress}
    >
      <NSText
        style={{
          flexShrink: 1,
          maxWidth: "90%",
          marginEnd: 10,
          fontSize: 14,
          color: "#303030",
        }}
        props={{ numberOfLines: 1 }}
        text={!!selectedItem ? selectedItem : defaultTitle}
      />
      <AntDesign name="caret-down" size={10} color="#6300A3" />
      {canClearFilter ? <ClearFilter onClearFilter={onClearFilter} /> : null}
    </TouchableOpacity>
  );
};

export default MultiSelectNestedDropDown;

const styles = StyleSheet?.create?.({
  container: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 4,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
});
